import Typography from '@mui/material/Typography';
import React from 'react';
import { ChevronLeft } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './page-section-base.style';

export type PageSectionBaseProps = {
  title?: string;
  url?: string;
  interactions?: React.ReactNode;
  fullSize?: boolean;
  grow?: boolean;
  hideBorder?: boolean;
  noPadding?: boolean;
  children: React.ReactNode;
};

export const PageSectionBase: React.FC<PageSectionBaseProps> = ({
  title,
  url,
  interactions,
  fullSize,
  grow,
  hideBorder,
  noPadding,
  children,
}) => (
  <Styled.Container $fullSize={!!fullSize} $grow={!!grow}>
    {!!title && (
      <Styled.Header $hideBorder={!!hideBorder}>
        <Styled.TitleContainer as={!url ? 'span' : undefined} to={url || ''}>
          <Typography variant="h6" component="h2">
            {title}
          </Typography>

          {!!url && (
            <Styled.ChevronContainer>
              <Icon icon={ChevronLeft} />
            </Styled.ChevronContainer>
          )}
        </Styled.TitleContainer>
        {interactions}
      </Styled.Header>
    )}

    <Styled.Body $hasTitle={!!title} $noPadding={!!noPadding}>
      {children}
    </Styled.Body>
  </Styled.Container>
);
